import React, { useState, useEffect } from "react";
import {db } from "../../Firebase/Firebase";
import { doc, getDoc } from "firebase/firestore";
import { collection, query, where, getDocs } from "firebase/firestore";
import "./Board.css";

const Board = ({ teamId, userId, user, teams="i" }) => {
  const dummyUser = {
    userId: "user123",
    userName: "John Doe",
    userRole: "Developer",
  };

  // Dummy task data
  const [dummyTasks, setDTasks] = useState([
    
  ]);

  const getTasks = async (teamId) => {
    const q = query(collection(db, "tasks"), where("teamId", "==", teams));
    let tasks = []
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      
      tasks.push({ ...doc.data(), id: doc.id });
    });
    setDTasks(tasks);
  }

  useEffect(() => {
    getTasks(teams);
  }, [teams]);




  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleActionButtonClick = (task) => {
    setSelectedTask(task);
    setSelectedOption(null); // Reset selected option when button is clicked
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleConfirmation = () => {
    console.log(`Updating task ${selectedTask.taskId} status to ${selectedOption}`);
    setSelectedTask(null);
    setSelectedOption(null);
  };

  const renderTasksByStatus = (status) => {
    const filteredTasks = dummyTasks.filter(
      (task) => task.status === status
    );

    return filteredTasks.map((task) => (
      <div key={task.id} className="task-card">
        <div className="task-card-header">
          <div>
           
            <span>
            
              <button className="round-orange"> </button>
            </span>
            <span>{task.name}</span>
          </div>
          <div> {task.dueDate} </div>
        </div>

        <div className="task-desc"> {task.description} </div>

        <div className="task-card-footer">
          <button className="action-button" onClick={() => handleActionButtonClick(task)} > Status</button>
          <div> {task.priority} </div>
        </div>


        {selectedTask === task && (
          <div className="confirmation-popup">
            <p>Select an option:</p>
            <select value={selectedOption} onChange={(e) => handleOptionSelect(e.target.value)}>
              <option value="backlog">Move to Backlog</option>
              <option value="closed">Close Task</option>
            </select>
            <button onClick={handleConfirmation}>Confirm</button>
          </div>
        )}
     
      </div>




    ));
  };

  return (
    <div className="tasks-container">
      <div className="pending-container">
        <h2>Pending Tasks</h2>
        {renderTasksByStatus("pending")}
      </div>

      <div className="wip-container">
        <h2>Work in Progress</h2>
        {renderTasksByStatus("wip")}
      </div>
      <div className="backlog-container">
        <h2>Backlog</h2>
        {renderTasksByStatus("backlog")}
      </div>

      {/* <div className="closed-container">
        <h2>Closed Tasks</h2>
        {renderTasksByStatus('closed')}
      </div> */}
    </div>
  );
};

export default Board;